"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocaleFlag = function LocaleFlag(_ref) {
  var _require;

  var intl = _ref.intl,
      selectedLocale = _ref.locale,
      style = _ref.style,
      className = _ref.className;
  var locale = selectedLocale || intl.locale;
  return /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: intl.formatMessage({
      id: locale
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "LocaleFlag ".concat(className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: locale,
    src: (_require = require("./flags/".concat(locale, ".svg"))) === null || _require === void 0 ? void 0 : _require.default
  })));
};

var _default = LocaleFlag;
exports.default = _default;